import { Encoder } from '@everyboard/lib';
import { Player, PlayerOrNone } from '../../jscaip/Player';
export class DvonnPieceStack {
    owner;
    size;
    source;
    static encoder = Encoder.tuple([Encoder.identity(), Player.encoder, Encoder.identity()], (stack) => [stack.source, stack.owner, stack.size], (fields) => {
        return new DvonnPieceStack(fields[1], fields[2], fields[0]);
    });
    static MAX_SIZE = 49; // The maximal possible size for a stack
    static EMPTY = new DvonnPieceStack(PlayerOrNone.NONE, 0, false);
    static UNREACHABLE = new DvonnPieceStack(PlayerOrNone.NONE, -1, false);
    static PLAYER_ZERO = new DvonnPieceStack(Player.ZERO, 1, false);
    static PLAYER_ONE = new DvonnPieceStack(Player.ONE, 1, false);
    static SOURCE = new DvonnPieceStack(PlayerOrNone.NONE, 1, true);
    static append(stack1, stack2) {
        return new DvonnPieceStack(stack1.owner, stack1.size + stack2.size, stack1.source || stack2.source);
    }
    constructor(owner, size, source) {
        this.owner = owner;
        this.size = size;
        this.source = source;
    }
    getOwner() {
        return this.owner;
    }
    belongsTo(player) {
        return this.owner === player;
    }
    containsSource() {
        return this.source;
    }
    isEmpty() {
        return this.size === 0;
    }
    hasPieces() {
        return this.isEmpty() === false;
    }
    getSize() {
        return this.size;
    }
    toString() {
        return 'DvonnPieceStack(' + this.owner.toString() + ', ' + this.size + ', ' + this.source + ')';
    }
    equals(other) {
        return this.owner === other.owner &&
            this.size === other.size &&
            this.source === other.source;
    }
}
